import React from "react";

// IMAGE IMPORT
import supportTeam from "../../assets/EMP_CallAndContact/call-center-hero.webp";
import topImage from "../../assets/EMP_GroceryTrustedSection/tips-promo-banner-inpage.webp";
import EMP_TrustedLogosSection  from "../../Components/EmployersComponents/EMP_CallAndContact/EMP_TrustedLogosSection";
import EMP_WhyChooseDailyPay from "../../Components/EmployersComponents/EMP_CallAndContact/EMP_WhyChooseDailyPay";
import EMP_ReceptionSection from "../../Components/EmployersComponents/EMP_CallAndContact/EMP_ReceptionSection";
import  EMP_FeaturedPartnerSection from "../../Components/EmployersComponents/EMP_CallAndContact/EMP_FeaturedPartnerSection";
import EMP_RealStoriesSection from "../../Components/EmployersComponents/EMP_CallAndContact/EMP_RealStoriesSection";
import EMP_SupportSections from "../../Components/EmployersComponents/EMP_CallAndContact/EMP_SupportSections";
import GroceryInsightsFormSection from "../../Components/EmployersComponents/EMP_grocery/GroceryInsightsFormSection";
import Footer from "../../Components/Footer";



const DailyPaySection = () => {
  return (
    <>
    <section className="w-full bg-white overflow-hidden">
      
      <div
        className="
          max-w-[1400px]
          mx-auto
          px-5
          sm:px-8
          md:px-12
          lg:px-20
          py-14
          sm:py-16
          md:py-20
          lg:py-24
        "
      >
        
        <div
          className="
            flex
            flex-col
            lg:flex-row
            items-center
            justify-between
            gap-12
            md:gap-16
            lg:gap-20
          "
        >
          
          {/* LEFT CONTENT */}
          <div className="flex-1 w-full text-center lg:text-left lg:-ml-[20px] mt-[100px] lg:mt-[70px]">

            {/* SMALL TAG */}
            <p
              className="
                text-[#c85d1c]
                uppercase
                tracking-[2px]
                font-bold
                text-[12px]
                sm:text-[14px]
                md:text-[15px]
                mb-5
                sm:mb-6
              "
            >
              Call & Contact Centers
            </p>

            {/* HEADING */}
            <h1
              className="
                text-[#2b0000]
                font-serif
                font-medium
                leading-[1.05]

                text-[38px]
                sm:text-[50px]
                md:text-[52px]
                lg:text-[52px]

                max-w-[800px]
                lg:max-w-[500px]
                mx-auto
                lg:mx-0
              "
            >
              So You’ve Heard All the Buzz about On-Demand Pay...
            </h1>

            {/* PARAGRAPH */}
            <p
              className="
                text-black
                mt-6
                sm:mt-8

                text-[15px]
                sm:text-[17px]
                md:text-[18px]
                lg:text-[15px]
                lg:max-w-[500px]
                lg:font-sans

                leading-[1.8]
                max-w-[700px]

                mx-auto
                lg:mx-0
              "
            >
              DailyPay was designed to help companies like yours to hire
              faster, reduce turnover and improve employee engagement. By
              offering on-demand pay, you’ll be providing employees with a
              much-needed lifeline, with an opportunity to do something
              profound that will shape the economy and ultimately deliver a
              better financial system for everyone.
            </p>

            {/* BUTTON */}
            <button
              className="
                mt-8
                lg:mt-6

                bg-[#2b0000]
                text-white

                px-5
                py-2.5

                text-[15px]
                font-semibold

                transition-all
                duration-300

                hover:bg-[#4b0000]
                hover:-translate-y-1
              "
            >
              Book a Demo
            </button>
          </div>

          {/* RIGHT IMAGE */}
          <div
            className="
              flex-1
              w-full
              flex
              justify-center
              items-center
              lg:mt-8
              lg:ml-[60px]
            "
          >
            <img
              src={supportTeam}
              alt="Support Team"
              className="
                w-full
                max-w-[320px]
                sm:max-w-[450px]
                md:max-w-[550px]
                lg:max-w-[700px]
                object-contain
              "
            />
          </div>

        </div>
      </div>
    </section>
    
        <section
          className="
            hidden lg:block
            relative
            left-1/2
            right-1/2
            -ml-[50vw]
            -mr-[50vw]
            w-screen
            bg-[#d0e3f1]
            overflow-visible
            py-4
            lg:h-[100px]
            lg:mt-[90px]
          "
        >
          <div
            className="
              w-full
              lg:w-full
              flex
              flex-col
              lg:flex-row
              items-center
              justify-between
              gap-10
              px-6
              lg:px-20
            "
          >
            {/* LEFT PHONE IMAGE */}
            <div
              className="
                lg:w-[35%]
                relative
                flex
                justify-center
                overflow-visible
                lg:mb-[47px]
                lg:ml-[50px]
              "
            >
              <img
                src={topImage}
                alt=""
                className="
                  w-full
                  max-w-[250px]
                  object-contain
                  relative
                  lg:-mt-[90px]
                  lg:ml-[50px]
                  z-20
                "
              />
            </div>
        
            {/* CENTER CONTENT */}
            <div className="lg:w-[45%] lg:-mt-[130px]">
        
              <span
                className="
                  inline-block
                  bg-[#d45500]
                  text-white
                  text-[14px]
                  font-bold
                  px-2.5
                  py-1
                  rounded-full
                  -ml-[100px]
                "
              >
                New
              </span>
        
              <h2
                className="
                  text-[#240000]
                  text-[32px]
                  lg:text-[20px]
                  leading-[1]
                  font-serif
                  lg:-ml-[100px]
                  lg:mt-[15px]
                "
                style={{
                //   fontFamily: "'Cormorant Garamond', serif",
                }}
              >
                DailyPay Tips
              </h2>
        
              <p
                className="
                  mt-1
                  text-[#120000]
                  text-[18px]
                  lg:text-[16px]
                  leading-[1.5]
                  max-w-[650px]
                  lg:-ml-[100px]
                "
              >
                Introducing real-time digital tips access powered by
                DailyPay.
              </p>
            </div>
        
            {/* RIGHT BUTTON */}
            <div className="lg:w-[20%] flex justify-center lg:justify-start -mt-[80px]">
              <button
                className="
                  border-2
                  border-[#16244d]
                  text-[#16244d]
                  hover:bg-[#16244d]
                  hover:text-white
                  px-4
                  py-2
                  rounded-full
                  text-[18px]
                  font-semibold
                  transition-all
                  duration-300
                "
              >
                Learn More
              </button>
            </div>
          </div>
        </section>

        <EMP_TrustedLogosSection />
        <EMP_WhyChooseDailyPay />
        <EMP_ReceptionSection />
        <EMP_FeaturedPartnerSection />
        <EMP_RealStoriesSection />
        <EMP_SupportSections />
         <GroceryInsightsFormSection />
         <Footer />

        </>
  );
};

export default DailyPaySection;